@if (isVisible()) {
  <app-form-card
    icon="pi pi-id-card"
    title="Assinatura de e-mail"
    description="Cargo, área e selos que saem na assinatura dos e-mails de RFQ ao banco e do Relatório de Posição."
    contentLayout="flex">
    @if (state() === 'loading') {
      <div class="signature-form__loading">
        <app-cog-loading-spinner [size]="48" />
      </div>
    } @else if (state() === 'error') {
      <p class="signature-form__notice signature-form__notice--error">
        <i class="pi pi-times-circle"></i>
        <span>{{ loadError() }}</span>
      </p>
    } @else {
      <div class="signature-form">
        <div class="signature-form__fields">
          <app-input
            [type]="'text'"
            [label]="'Cargo'"
            [placeholder]="'Ex.: Risk Analyst'"
            [maxLength]="fieldMaxLength"
            [ngModel]="jobTitle()"
            (ngModelChange)="jobTitle.set($event ?? '')"
            [ngModelOptions]="{ standalone: true }">
          </app-input>

          <app-input
            [type]="'text'"
            [label]="'Área'"
            [placeholder]="'Ex.: Mesa de Operações e Risco'"
            [maxLength]="fieldMaxLength"
            [ngModel]="department()"
            (ngModelChange)="department.set($event ?? '')"
            [ngModelOptions]="{ standalone: true }">
          </app-input>
        </div>

        <div class="signature-form__seals">
          <app-select
            [label]="'Selos de certificação'"
            [placeholder]="'Escolha os selos'"
            [multiple]="true"
            [options]="sealOptions()"
            [disabled]="state() === 'new'"
            [emptyMessage]="'Nenhum selo ativo. Cadastre na tela Selos de certificação.'"
            [selectedItemsLabel]="'{0} selos escolhidos'"
            [ngModel]="sealIds()"
            (ngModelChange)="onSealsChange($event)"
            [ngModelOptions]="{ standalone: true }">
            <ng-template let-item>
              <span class="signature-form__option">
                @if (item?.data?.imageUrl) {
                  <img [src]="item.data.imageUrl" [alt]="'Selo ' + item.label" />
                }
                <span>{{ item.label }}</span>
              </span>
            </ng-template>
          </app-select>

          @if (state() === 'new') {
            <small class="signature-form__hint">Salve o usuário para escolher os selos.</small>
          }
        </div>

        @if (selectedSeals().length) {
          <div class="signature-form__preview">
            <span class="signature-form__preview-label">Como a fileira sai no e-mail</span>
            <div class="signature-form__preview-row">
              @for (seal of selectedSeals(); track seal.id) {
                <img [src]="seal.imageUrl" [alt]="'Selo ' + seal.name" [title]="seal.name" />
              }
            </div>
          </div>
        }
      </div>
    }
  </app-form-card>
}
